import React from 'react'
import { IReportTableItem } from '../types/table'
import TableBody from '../../../procedures/Q8/Layouts/Table/TableBody'
import TableRow from '../../../procedures/Q8/Layouts/Table/TableRow'
import TableBodyCell from '../../../procedures/Q8/Layouts/Table/TableBodyCell'

type Props = {
  data: IReportTableItem[]
}

const ReportTableBody = ({
  data
}: Props) => {
  return (
    <TableBody>
      {
        data.map((item, index) => (
          <TableRow key={index}>
            {item.map((cell, index) => (
              <TableBodyCell key={index}>{cell}</TableBodyCell>
            ))}
          </TableRow>
        ))
      }
    </TableBody>
  )
}

export default ReportTableBody